import { render, staticRenderFns } from "./ProjectsSelector.vue?vue&type=template&id=e7a50d2c&scoped=true&"
import script from "./ProjectsSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSelector.vue?vue&type=style&index=0&id=e7a50d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a50d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
